import React from 'react'

function NoVenue() {
  return (
    <div className="bg-black min-h-screen flex items-center justify-center ">
      <span className="text-gray-600 text-4xl text-center">No venue found.</span>
    </div>
  )
}

export default NoVenue
